//  线上服务
export const baseUrl = 'http://wkt.littlewindy.com/php/'; 
export const mediaUrl = 'http://wktqn.littlewindy.com/'; 







//////////////////
// WEBPACK FOOTER
// ./static/config.js
// module id = null
// module chunks = 